import { Box as MuiBox, styled as muiStyled } from "@mui/material";

export const Box = muiStyled(MuiBox)`
  &.container {
    width: 100%;
    height: 100%;
  }

  &.content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 3%;
  }

  &.title {
    font-size: 4vw;
    font-weight: bold;
    margin-bottom: 40px;

    b {
      font-weight: 800;
    }
  }

  &.buttons-container {
    display: flex;
    flex-direction: column;
    gap: 5vw;
  }

  &.button-row {
    display: flex;
    justify-content: space-between;
  }

  &.button-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
